import { combineReducers } from 'redux'
import { createRequestingReducer, createErrorReducer } from '../../utils/reducer'
import injectReducer from '../../state/hoc/injectReducer';
import { verificationRoutine } from './routines'

const REDUCER_KEY = 'accountVerification'

export const requesting = createRequestingReducer(
  verificationRoutine.REQUEST,
  verificationRoutine.FULFILL
)

export const error = createErrorReducer(
  verificationRoutine.FAILURE,
  verificationRoutine.SUCCESS
)

const reducer = combineReducers({
  requesting,
  error
})

export const withReducer = injectReducer({
  key: REDUCER_KEY,
  reducer
})

export default reducer
